const _ = require('lodash')
const moment = require('moment')

/**
 * Get full media url
 * @param {String} uri
 */
export function getMediaUrl(uri) {
  const mediaHost = process.env.VUE_APP_MEDIA_HOST
  if (!_.startsWith(uri, 'http')) {
    uri = _.trimEnd(mediaHost, '/') + '/' + _.trimStart(uri, '/')
  }
  return uri
}

export function getDate(time) {
  return moment(time).format('DD-MM-YYYY')
}

export function getDateTime(time) {
  return moment(time).format('HH:mm, DD-MM-YYYY')
}

export function vnd(num) {
  return Intl.NumberFormat('vi-vn', {
    style: 'currency',
    currency: 'VND'
  }).format(num)
}
